import React from 'react';
import { Box, Button, Grid, GridItem, HStack } from '@chakra-ui/react';

interface KeypadProps {
  value: string;
  onChange: (val: string) => void;
  onSubmit: (value: string) => void;
}

const keys = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['Skip', '0', '⌫'],
];

const Keypad: React.FC<KeypadProps> = ({ value, onChange, onSubmit }) => {
  const handleKeyPress = (key: string) => {
    if (key === 'Skip') {
      onSubmit('0');
    } else if (key === '⌫') {
      onChange(value.slice(0, -1));
    } else if (/^\d$/.test(key)) {
      onChange(value + key);
    }
  };

  return (
    <Box w="100%"  mx="auto">
      <Box
        mb={4}
        p={3}
        borderRadius="lg"
        bg="whiteAlpha.900"
        fontSize="2xl"
        fontWeight="bold"
        textAlign="right"
        boxShadow="md"
        minH="56px"
      >
        {value || ' '}
      </Box>
      <Grid templateColumns="repeat(3, 1fr)" gap={3}>
        {keys.flat().map((key, idx) => (
          <GridItem key={key + idx}>
            <Button
              w="100%"
              h="60px"
              fontSize="2xl"
              borderRadius="xl"
              colorScheme={key === 'Skip' ? 'red' : key === '⌫' ? 'orange' : 'teal'}
              variant={key === 'Skip' ? 'outline' : 'solid'}
              onClick={() => handleKeyPress(key)}
              _active={{ transform: 'scale(0.97)' }}
              boxShadow="md"
            >
              {key}
            </Button>
          </GridItem>
        ))}
      </Grid>
      <HStack mt={4}>
        <Button
          colorScheme="teal"
          w="100%"
          size="lg"
          borderRadius="xl"
          fontWeight="bold"
          fontSize="xl"
          onClick={() => onSubmit(value)}
          disabled={!value}
          boxShadow="lg"
        >
          Submit
        </Button>
      </HStack>
    </Box>
  );
};

export default Keypad; 